import { useStoredCart } from "./storage.mjs";
import { resolveCartOptions, resolveCartRouteOptions } from "./utils.mjs";
import { useResetCart } from "./clear-cart.mjs";
import errorsObj from "../../exceptions.mjs";
import { GuestCartDocument } from "../../graphql/Cart.mjs";
import { useChannels, topics } from "../channels.mjs";
import { useExceptions } from "../exceptions.mjs";
import { isEmpty } from "lodash-es";
import { useQuery } from "villus";
import { useRoute, watch } from "#imports";
export function useGuestCart() {
  const { execute, isFetching } = useQuery({
    query: GuestCartDocument.toString(),
    fetchOnMount: false,
    cachePolicy: "network-only"
  });
  const route = useRoute();
  const { resetCart } = useResetCart();
  const { subscribe, unsubscribe } = useChannels();
  const { resolveException } = useExceptions("cart");
  const { cartState, patchCartState, mapCartState, isFetchingCart } = useStoredCart();
  async function getCart(opts = {}) {
    const { data, error } = await execute({
      variables: {
        cartId: cartState.value.cartId,
        ...resolveCartOptions("guestCart"),
        ...opts
      }
    });
    if (error && resolveException(error).message === errorsObj.cart.invalidCartStore.key) {
      resetCart();
    }
    if (error && resolveException(error).level === "DANGER") {
      throw new Error(error.message);
    }
    if (data?.cart) {
      patchCartState(mapCartState(data?.cart));
    }
    const unwatch = watch(
      () => route.name,
      async (newRoute) => {
        const option = resolveCartRouteOptions("guestCart", newRoute);
        if (!isEmpty(option)) {
          await getCart(option);
          unwatch();
        }
      }
    );
    const cb = () => {
      unwatch();
      unsubscribe(topics.auth.identify, cb);
    };
    subscribe(topics.auth.identify, cb);
  }
  watch(isFetching, (value) => {
    isFetchingCart.value = value;
  });
  return {
    getCart
  };
}
